import React, { useState } from 'react';
import UploadTab from './UploadTab';
import ManageTab from './ManageTab';
import { useTranslation } from '../../../hooks/useTranslation';

const LanguageManagement = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('upload');
  const [platform, setPlatform] = useState('web');

  const tabs = [
    { id: 'upload', name: t('languageManagement').tabs.upload, component: UploadTab },
    { id: 'manage', name: t('languageManagement').tabs.manage, component: ManageTab }
  ];


  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;
  

  return (
    <div className="min-h-screen bg-gray-50 py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header & Platform Selector */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8 gap-4 md:gap-0">
          <div>
            <h1 className="text-3xl font-extrabold text-gray-900 mb-1">{t('languageManagement').title}</h1>
            <p className="text-gray-600">{t('languageManagement').description}</p>
          </div>

          <div className="flex items-center space-x-2">
            <label className="text-gray-700 font-medium">{t('languageManagement').platform}</label>
            <select
              value={platform}
              onChange={(e) => setPlatform(e.target.value)}
              className="border border-gray-300 rounded-md px-3 py-1.5 shadow-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
            >
              <option value="web">{t('languageManagement').platformOptions.web}</option>
              <option value="app">{t('languageManagement').platformOptions.mobile}</option>
            </select>
          </div>
        </div>

        {/* Tabs */}
        <div className="mb-6 bg-white rounded-lg shadow-sm">
          <nav className="flex space-x-6 border-b border-gray-200 px-4 sm:px-6">
            {tabs?.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-3 px-1 text-sm font-medium transition-colors duration-200 ${
                  activeTab === tab.id
                    ? 'border-b-2 border-green-500 text-green-600'
                    : 'text-gray-500 hover:text-gray-700 hover:border-b-2 hover:border-gray-300'
                }`}
              >
                {tab.name}
              </button>
            ))}
          </nav>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          {ActiveComponent && <ActiveComponent platform={platform} />}
        </div>
      </div>
    </div>
  );
};

export default LanguageManagement;
